export const currency = {
  computed: {
    currency (value) {
      let amount = value
      let extension = ''
      amount = Math.round(amount)
      amount = new Intl.NumberFormat('en-US').format(amount)
      if (amount < 999998) {
        amount = Math.round(amount)
      }
      if (amount > 999999999) {
        amount = Math.round(amount / 1000000000).toFixed(2)
        extension = 'B'
      }
      return '$' + amount + extension
      // return '$' + state.value.toLocaleString()
    }
  }
}
